import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Share = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M20 3C20.2652 3 20.5196 3.10536 20.7071 3.29289L26.7071 9.29289C27.0976 9.68342 27.0976 10.3166 26.7071 10.7071C26.3166 11.0976 25.6834 11.0976 25.2929 10.7071L21 6.41421V26C21 26.5523 20.5523 27 20 27C19.4477 27 19 26.5523 19 26V6.41421L14.7071 10.7071C14.3166 11.0976 13.6834 11.0976 13.2929 10.7071C12.9024 10.3166 12.9024 9.68342 13.2929 9.29289L19.2929 3.29289C19.4804 3.10536 19.7348 3 20 3ZM7 16C7 14.8954 7.89543 14 9 14H12.8C13.3523 14 13.8 14.4477 13.8 15C13.8 15.5523 13.3523 16 12.8 16H9V35H31L31 16H27.2C26.6477 16 26.2 15.5523 26.2 15C26.2 14.4477 26.6477 14 27.2 14H31C32.1046 14 33 14.8954 33 16V35C33 36.1046 32.1046 37 31 37H9C7.89543 37 7 36.1046 7 35V16Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Share;
